/** Simple inline plant — avoids opaque PNG background boxes. */
export function MotivationPlant({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      aria-hidden="true"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="32" cy="58" rx="18" ry="5" fill="currentColor" className="text-primary/15" />
      <path
        d="M20 56c0-10 4-18 12-24 8 6 12 14 12 24H20z"
        fill="currentColor"
        className="text-primary"
      />
      <path
        d="M32 32c-6 4-10 10-10 18h20c0-8-4-14-10-18z"
        fill="currentColor"
        className="text-primary/80"
      />
      <path d="M32 20c-2 6-2 12 0 18 2-6 2-12 0-18z" fill="#22c55e" />
      <path d="M24 26c4 2 6 6 6 12 0-4-2-8-6-12z" fill="#16a34a" />
      <path d="M40 26c-4 2-6 6-6 12 0-4 2-8 6-12z" fill="#16a34a" />
      <path d="M28 14c2 4 2 8 0 12 2-2 4-6 4-10 0 2-2 4-4-2z" fill="#22c55e" />
      <path d="M36 14c-2 4-2 8 0 12-2-2-4-6-4-10 0 2 2 4 4 2z" fill="#22c55e" />
    </svg>
  );
}
